import { useQuery } from "@tanstack/react-query";
import React from "react";
import { NavLink } from "react-router-dom";
import Loader from "../../../components/loader/Loader";
import axiosaim from "../../../api/axiosaim";
import '../ndot.scss';
import Departments from "../../../components/ndot/Department";
import AllNDOTRequests from "../../../components/ndot/AllRequests";

const Requests = () => {
    const aimtoken = sessionStorage.getItem('aimtoken') || '';
    const departmentslug = sessionStorage.getItem('departmentslug') || '';
    const uname = sessionStorage.getItem('uname'); 

    const { data: manageddepartments, isLoading: isLoadingDepartments } = useQuery({
        queryKey: ['managedAIMDepartments', uname],
        queryFn: async () => {
            const res = await axiosaim.get(`getmanageddepartments`, {
                headers: { 'X-Aim-Token': aimtoken }
            });
            return res.data;
        },
        enabled: !!uname && !!aimtoken,
        retry: 1
    });

    return (
        <div className="ndot ndot-requests">
            <div className="page-header">
                <div className='title'>
                    <h1>NDOT Requests</h1>
                    <ul className='breadcrumbs'>
                        <li>
                            <NavLink to='/nd-ot/my-request'>NDOT</NavLink>
                        </li>
                        <li>
                            <span>All Requests</span>
                        </li>
                    </ul>
                </div>
            </div>

            { isLoadingDepartments 
                ? (
                    <div className="columns">
                        <Loader />
                    </div>
                ) 
                : manageddepartments?.length > 1
                    ? (
                        <Departments departments={manageddepartments} loading={isLoadingDepartments} />
                    ) : (
                        <AllNDOTRequests departmentslug={departmentslug} />
                    )
            }

        </div>
    )
}

export default Requests;